<template>
  <router-link to="/settings/integrations" class="integration-icons" :class="profile && profile.company_data ? '' : 'mt-none'">
    <div 
      v-for="integration in activeIntegrations"
      v-bind:key="integration.id"
      class="icon"
      :class="small ? '--small' : ''"
      >
      <img 
        :key="integration.id"
        :title="(integration.name) ? integration.name : integration.type"
        v-b-tooltip.hover.top
        :src="getSvgIntegrationIcon(`${integration.type}`)" 
        :alt="integration.type" 
      />
    </div>
  </router-link>
</template>

<script>
import { mapState } from "vuex";
import { getSvgIntegrationIcon } from "../../utils/url";

export default {
  props: {
    only: { type: String },
    small: { type: Boolean }
  },
  methods: {
    getSvgIntegrationIcon
  },
  computed: {
    ...mapState({
      profile: state => state.user.dadosCompletos,
      integrations: state => state.integrations.integrations,
    }),
    activeIntegrations() {
      return (this.only) ? this.integrations.filter(i => i.category === this.only) : this.integrations;
    }
  },
};
</script>

<style lang="scss" scoped>
.integration-icons {
  display: flex;
  height: auto;
  gap: .2rem;
  // margin-left: 15px;
  width: auto;

  .icon {
    background-color: white;
    border: 1px solid rgba(0,0,0,.5);
    border-radius: 999px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    overflow: hidden;
    width: 42px;
    transform: translateX(-40%);

    &:first-child {
    transform: translateX(0);
    }

    &.--small {
      height: 24px;
      width: 24px;

      img {
        height: 80%;
        width: 80%;
      }
    }

    img {
      object-fit: cover;
      height: 60%;
      width: 60%;
    }
  }
}
</style>
